var r=function(r,n){for(var t=-1,e=n.length,a=r.length;++t<e;)r[a+t]=n[t];return r};export{r as _};
//# sourceMappingURL=_arrayPush-53d24997.js.map
